import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { EatingWaySettingListItem } from './models';

const eatingWaySettingService = {
  getAll(eatingWayId: number): Promise<CommonResponse<Array<EatingWaySettingListItem>>> {
    const url = `/eating-way-settings?eating_way_id=${eatingWayId}`;
    return axiosClient.get(url);
  },
  update(eatingWayId: number, saleTypeId: number, payload: EatingWaySettingListItem[]): Promise<CommonResponse<any>> {
    const url = `/eating-way-settings?eating_way_id=${eatingWayId}&sale_type_id=${saleTypeId}`;
    return axiosClient.put(url, payload);
  },
};

export default eatingWaySettingService;
